<template>
    <div class="p-2" v-if="currentItem">
        <h3 style="color: #2662bb;" class="ml-1">详情</h3>
        <form-view :item="currentItem" :fields="detailFields"></form-view>
    </div>
</template>

<script>

import FormView from "@/components/common/display/FormView.vue";

export default {
    name: "HazardDetail",
    components: {FormView},
    props: {
        currentItem: Object
    },
    data() {
        return {
            detailFields: [
                {name: 'staffType', label: '人员类别', type: 'select', optionsFromDict: 'ehs_hazard_staff_type'},
                {
                    name: 'position',
                    label: '安全员点位',
                    type: 'select',
                    optionsFromDict: 'ehs_hazard_position'
                },
                {name: 'findAt', label: '隐患位置', type: 'select', optionsFromDict: 'ehs_hazard_find_at'},
                {name: 'description', label: '隐患描述', type: 'textarea'},
                {
                    name: 'hazardStatus', label: '隐患处理状态', type: 'radio', options: [
                        {value: 1, label: '待整改'},
                        {value: 2, label: '停机'},
                        {value: 3, label: '已整改'},
                    ]
                },
                {name: 'hazardImage', label: '隐患照片', type: 'image', multiple: true},
                {name: 'rectificationImage', label: '整改照片', type: 'image', multiple: true},
                {
                    name: 'rectifyDept',
                    label: '隐患整改部门',
                    type: 'select',
                    optionsFromDict: 'ehs_hazard_rectify_dept'
                },
            ]
        }
    },
}
</script>

<style scoped>

</style>
